import { Action } from '@op/opds.opux';
import { isLinkObject, type LinkObject } from '../../../types';

interface Props {
  texts: Array<string | LinkObject> | undefined;
  as?: keyof JSX.IntrinsicElements;
  itemClassName?: string;
}

const LocalizedTextList = ({
  texts,
  as: Component = 'p',
  itemClassName,
}: Props) => (
  <>
    {texts?.map((text) => {
      if (isLinkObject(text)) {
        return (
          <Component key={text.linkUrl}>
            <Action href={text.linkUrl}>{text.linkText}</Action>
          </Component>
        );
      } else {
        return (
          <Component key={text} className={itemClassName}>
            {text}
          </Component>
        );
      }
    })}
  </>
);

export default LocalizedTextList;
